module.exports = __webpack_public_path__ + "static/media/promo.55b7cbfb.png";